export enum MessagingCampaignTriggerMechanism {
  scheduled = 'scheduled',
  event = 'event',
}

export enum MessagingCampaignActivationType {
  triggerBasedActivation = 'triggerBasedActivation',
  customDateActivation = 'customDateActivation',
}

export enum CustomerBrandCommunicationType {
  orderReceiptMessage = 'orderReceiptMessage',
  postPurchaseConnectMessage = 'postPurchaseConnectMessage',
  reviewRequestMessage = 'reviewRequestMessage',
  reorderRequestMessage = 'reorderRequestMessage',
  rewardRecommendationsMessage = 'rewardRecommendationsMessage',
  productRecommendationsMessage = 'productRecommendationsMessage',
}
